import { useState } from "react";
import { Button, DatePicker, Flex, ModalV2, Text } from "@jsq/ds/core";
import { Colors } from "@jsq/ds/styles";
import { SPACING } from "~/styles/variables";
import { CaseTypeDisplay } from "../types";

export type EditFirstCapitalCallDateModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (date: Date) => void;
  selectedEntityCount: number;
};

export const EditFirstCapitalCallDateModal = ({
  isOpen,
  onClose,
  onSubmit,
  selectedEntityCount,
}: EditFirstCapitalCallDateModalProps) => {
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleClose = () => {
    setSelectedDate(null);
    onClose();
  };

  const handleSubmit = () => {
    if (selectedDate) {
      onSubmit(selectedDate);
      setSelectedDate(null);
    }
  };

  if (!isOpen) {
    return null;
  }

  const entityLabel = selectedEntityCount === 1 ? "entity" : "entities";

  return (
    <ModalV2
      show={isOpen}
      onHide={handleClose}
      title={`Edit ${CaseTypeDisplay.FirstCapitalCallDate.toLowerCase()}`}
      description={`${selectedEntityCount} selected ${entityLabel}`}
      data-testid="edit-first-capital-call-date-modal"
    >
      <ModalV2.Body>
        <Flex flexDirection="column" gap={SPACING.SMALL}>
          <Text variant="secondary-md" color={Colors.Neutral900}>
            {CaseTypeDisplay.FirstCapitalCallDate}
          </Text>
          <DatePicker
            selected={selectedDate}
            onChange={(date: Date | null) => setSelectedDate(date)}
            dateFormat="MMM dd, yyyy"
            placeholderText="Select date"
            isFull
            hasIcon
            popperPlacement="bottom-start"
          />
        </Flex>
      </ModalV2.Body>
      <ModalV2.Footer>
        <Flex justifyContent="flex-end" gap={SPACING.SMALL}>
          <Button variant="neutral" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleSubmit}
            disabled={!selectedDate}
            data-testid="submit-first-capital-call-date"
          >
            Submit for approval
          </Button>
        </Flex>
      </ModalV2.Footer>
    </ModalV2>
  );
};
